import React, {
  FunctionComponent,
  useContext,
  useState,
  useEffect,
} from "react";
import { Helmet } from "react-helmet";
import { ContentPage } from "../../services/entities/content";
import { Space } from "../../services/entities/spaces";
import { ContentPageContext } from "../content/context";

type SookHelmetProps = {
  value?: ContentPage | Space | null;
};

export const SookHelmet: FunctionComponent<SookHelmetProps> = ({ value }) => {
  const page = useContext(ContentPageContext);
  const [pageState, setPageState] = useState<SookHelmetProps>({});

  useEffect(() => {
    value
      ? setPageState({
          value: value,
        })
      : setPageState({
          value: page,
        });
  }, [page, value]);

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <meta property="og:image" content="https://sook-web-prod-resources.s3.amazonaws.com/spaces/oxford-street-london/images/10.jpg" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
      <meta name="apple-mobile-web-app-title" content="Sook" />
      <meta name="application-name" content="Sook" />
      <meta name="msapplication-TileColor" content="#da532c" />
      <meta name="theme-color" content="#ffffff" />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Asap:400,500,600&display=swap"
      />
      <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />

      {pageState && pageState.value?.pageTitle ? (
        <title itemProp="name" lang="en">
          {pageState.value?.pageTitle}
        </title>
      ) : (
        <title itemProp="name" lang="en">
          Sook - Adaptive Retail Spaces
        </title>
      )}
      {pageState && pageState.value?.pageTitle ? (
        <meta property="og:title" content={pageState.value?.pageTitle} />
      ) : (
        <meta property="og:title" content="Sook - Adaptive Retail Spaces" />
      )}
      {pageState && pageState.value?.metaDescription ? (
        <meta name="description" content={pageState.value?.metaDescription} />
      ) : (
        <meta name="description" content="Book High Street space by the hour" />
      )}
      {pageState && pageState.value?.metaDescription ? (
        <meta
          property="og:description"
          content={pageState.value?.metaDescription}
        />
      ) : (
        <meta
          property="og:description"
          content="Book High Street space by the hour"
        />
      )}

      {/* <link rel="canonical" href="http://mysite.com/example" /> */}

      <script
        type="text/javascript"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
      ></script>
    </Helmet>
  );
};

export default SookHelmet;
